// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3tiqpjIPAfhy9y--_jmES4","icons":"wDGFQT7LeI1WlEy-nQTmB","total":"_49kqo64s3meBcaVQw5yIv","btn":"_1CgfLCW0yOf4FurXb9gEyj"};